import { render, staticRenderFns } from "./SharedIcon.vue?vue&type=template&id=28097eb6&scoped=true&"
import script from "./SharedIcon.vue?vue&type=script&lang=js&"
export * from "./SharedIcon.vue?vue&type=script&lang=js&"
import style0 from "./SharedIcon.vue?vue&type=style&index=0&id=28097eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28097eb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('28097eb6', component.options)
    } else {
      api.reload('28097eb6', component.options)
    }
    module.hot.accept("./SharedIcon.vue?vue&type=template&id=28097eb6&scoped=true&", function () {
      api.rerender('28097eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/common_components/SharedIcon.vue"
export default component.exports